var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.6331,
    cy: 80.178,
    r: 79.8362,
    fill: "#E23333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0779 53.6799L80.6334 73.2353L100.088 53.7812C100.517 53.3238 101.035 52.9579 101.609 52.7055C102.184 52.453 102.804 52.3192 103.431 52.312C104.775 52.312 106.063 52.8458 107.014 53.7959C107.964 54.746 108.497 56.0346 108.497 57.3782C108.509 57.9993 108.394 58.6163 108.159 59.1913C107.924 59.7663 107.573 60.2871 107.13 60.7219L87.4221 80.176L107.13 99.8835C107.965 100.7 108.454 101.807 108.497 102.974C108.497 104.317 107.964 105.606 107.014 106.556C106.063 107.506 104.775 108.04 103.431 108.04C102.786 108.067 102.141 107.959 101.54 107.724C100.938 107.488 100.392 107.13 99.9355 106.672L80.6334 87.1167L61.1286 106.621C60.7005 107.064 60.1891 107.417 59.6239 107.66C59.0587 107.904 58.4509 108.033 57.8356 108.04C56.4919 108.04 55.2033 107.506 54.2532 106.556C53.3031 105.606 52.7694 104.317 52.7694 102.974C52.7576 102.353 52.8728 101.736 53.108 101.161C53.3432 100.586 53.6935 100.065 54.1372 99.6302L73.8447 80.176L54.1372 60.4686C53.3023 59.6517 52.8126 58.5455 52.7694 57.3782C52.7694 56.0346 53.3031 54.746 54.2532 53.7959C55.2033 52.8458 56.4919 52.312 57.8356 52.312C59.0514 52.3272 60.2167 52.8186 61.0779 53.6799Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.41002b8f.svg";
export { ForwardRef as ReactComponent };